import React, { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import "./resetPassword.css"
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../HomeScreen/Footer/Footer";
import { Link } from "react-router-dom";
import logoWhite from '../../image/logo/logoWhite.svg'
import logoBlack from '../../image/logo/logoBlack.svg'
import QWhite from '../../image/logo/QWhite.svg'
import { passwordPattern } from "../../components/types/types";
import DOMPurify from "dompurify";
import { GiCheckMark } from "react-icons/gi";

const ResetPassword = () => {

    const {token} = useParams()

    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');

    const [validPassword,setValidPassword] = useState(true)
    const [validConfirmPassword,setValidConfirmPassword] = useState(true)
    const [patternPassword,setPatternPassword] = useState(false)
    const [showPassword,setShowPassword] = useState(false)
    const [showPasswordConfirm,setShowPasswordConfirm] = useState(false)
    
    const [infoSucces,setInfoSucces] = useState(false)
    
    
    const navigate = useNavigate()

    const clickShowPassword = (id:string,confirm:boolean=false) => {
        confirm ? setShowPasswordConfirm(!showPasswordConfirm) : setShowPassword(!showPassword);
        const passwordInput = document.getElementById(id)
        if(passwordInput) {
            let type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password' 
            passwordInput.setAttribute('type', type);
        }
    }


    const clickReinit = async () => {
        if(password.length < 8 ) {
            setValidPassword(false)
        }
        else {
            setValidPassword(true)
            confirmPassword !== password ? setValidConfirmPassword(false) : setValidConfirmPassword(true)
        }
      
        if((password.length>=8) && ( confirmPassword === password)) {
            const cleanMdp = DOMPurify.sanitize(password);
            if (passwordPattern.test(cleanMdp)) {
                try {
                    await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/reset-password`, { 
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            token: token,
                            password: password
                        }),
                    });
                    setInfoSucces(true)
                    setTimeout(() => navigate("/"), 5000) 
                } catch (error) {
                    
                }
            } else {
                setPatternPassword(true)
            }
        }
    
    }

    const [tokenValid,setTokenValid] = useState(false)
    useEffect(() => {
        const verifyToken = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/verify-reset-token?token=${token}`, { 
                    method: 'GET',
                });
                const data = await  response.json()
                setTokenValid(data.valid)
            } catch(error) {
                setTokenValid(false)
            }
        }

        verifyToken()
    },[token])




    return (
        <div className='resetPwdPage' >
            <div className='topBarRestPwdPage'>
                <Link to={"/"} className="containerImg">
                    <img className="logoTopBar" src={logoWhite} loading="lazy" alt="logo"/>
                    <img className="logoTopBarTel" src={QWhite} loading="lazy" alt="logo"/> 
                </Link>
                <p className="largeTitle">Réinitialiser votre mot de passe</p>
            </div>
            <div className="mainCorp">
            { tokenValid ? (
                
                <div className='resetPasswordContainer primaryBack' >
                    {!infoSucces ? (
                        <>
                        <img src={logoBlack} loading="lazy" alt="logo"/>


                        <div className="corp">
                            <p className="textInput smallTextBold" style={validPassword ? {} : {color : "red"}}>
                                { validPassword ?
                                    "Mot de passe" : "Mot de passe trop court" }
                                
                            </p> 
                            {patternPassword &&  <>
                                        <p className="patternPassword smallText">Le mot de passe doit contenir une majuscule.</p>
                                        <p className="patternPassword smallText">Le mot de passe doit contenir un chiffre.</p>
                                        <p className="patternPassword smallText">Le mot de passe doit contenir un caractères spécial (!, @, #, $, %, *, /, ^, .).</p>
                                    </>
                            }
                            <div className="inputContainer" >
                                <input type="password" className="smallText inputLogin" id="inputRegisterPasswordRecup" placeholder="Nouveau mot de passe" style={validPassword ? {} : {border: "1px solid red"}} value={password} onChange={(e) => setPassword(e.target.value)} maxLength={128}/>
                                {showPassword ? <FiEyeOff className="eyeInputRecup  pointer" size={22} onClick={() => clickShowPassword("inputRegisterPasswordRecup")}/> : <FiEye className="eyeInputRecup pointer" size={22} onClick={() => clickShowPassword("inputRegisterPasswordRecup")}/>}
                            </div>

                            <p className="textInput smallTextBold" style={validConfirmPassword ? {} : {color : "red"}}>
                                { validConfirmPassword ?
                                    "Confirmer le mot de passe" : "Mot de passe différent" }
                            </p> 
                            <div className="inputContainer" >
                                <input type="password" className="smallText inputLogin" id="inputRegisterConfirmPasswordRecup" placeholder="Confirmer le mot de passe" style={validConfirmPassword ? {} : {border: "1px solid red"}} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} maxLength={128}/>
                                {showPasswordConfirm ? <FiEyeOff className="eyeInputRecup pointer" size={22} onClick={() => clickShowPassword("inputRegisterConfirmPasswordRecup",true)}/> : <FiEye className="eyeInputRecup pointer" size={22} onClick={() => clickShowPassword("inputRegisterConfirmPasswordRecup",true)}/>}
                            </div>
                        </div>

                        <div className='button midTextBold pointer lowOpacityHover ' onClick={clickReinit}>Réinitialiser</div>
                        </> )
                        : 
                        <div className="containerSend">
                            <img src={logoBlack} style={{marginTop:'2em'}} loading="lazy" alt="logo"/>
                            <GiCheckMark size={60} style={{marginTop:"3em"}} className="iconCheck"/>
                            <p className="midTextBold" style={{marginBottom:"1em",marginTop:"2em"}}>Votre mot de passe a été réinitialisé</p>
                            <p className="smallText" style={{opacity:0.7}}>Vous allez être redirigé vers la page d'acceuil</p>
                        </div>  }
                </div>

                )
                :
                <div className='noneJWTContainer'></div>
            }
            
            </div>
            <Footer isResto={true}/>
        </div>
    )
}

export default ResetPassword